var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rowGridFormat" },
    [
      _c(
        "f7-grid",
        { staticClass: "menuIcon" },
        [
          !_vm.hideSecondProfile
            ? _c(
                "f7-col",
                { attrs: { width: _vm.centered ? 33 : 50 } },
                [
                  _c(
                    "center",
                    {
                      staticClass: "leftCol",
                      style: { "margin-left": _vm.marginValue + "px" },
                    },
                    [_vm._t("leftCol")],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.centered
            ? _c(
                "f7-col",
                { attrs: { width: "33" } },
                [
                  _c(
                    "center",
                    { staticClass: "centerCol" },
                    [_vm._t("centerCol")],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "f7-col",
            { attrs: { width: _vm.centered ? 33 : 50 } },
            [
              _c(
                "center",
                {
                  staticClass: "rightCol",
                  style: { "margin-right": _vm.marginValue + "px" },
                },
                [_vm._t("rightCol")],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }